// extracted by mini-css-extract-plugin
export var container = "subscribeFormFull-module--container--m_N8s";
export var formWrap = "subscribeFormFull-module--formWrap--1kwXK";